import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css';
import logo from "../assets/logo_ivt.png"

const MentionLegales = () => {
    const [privacyData, setPrivacyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchPrivacyPolicy();
    }, []);

    const fetchPrivacyPolicy = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Mentions-legales`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.success && data.data) {
                setPrivacyData(data.data);
            } else {
                throw new Error('Données non disponibles');
            }
        } catch (err) {
            console.error('Erreur:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="privacy-loading">
                <div className="spinner"></div>
                <p>Chargement...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="privacy-error">
                <p>Erreur : {error}</p>
            </div>
        );
    }

    if (!privacyData) {
        return null;
    }

    return (
        <div className="privacy-page">
            {/* Div 1 : Image */}
            <div className="privacy-image-container">
                {/* {privacyData.image_principale && ( */}
                <img
                    src={logo}
                    alt={privacyData.titre || "Mentions légales"}
                    className="privacy-image"
                />
                {/* )} */}
            </div>

            {/* Div 2 : Titre */}
            <div className="privacy-title-container">
                <h1 className="privacy-title" style={{fontSize: "24px"}}>
                    {privacyData.titre || "Mentions légales"}
                </h1>
            </div>

            {/* Div 3 : Contenu */}
            <div className="privacy-content-container">
                <div
                    className="privacy-content"
                    dangerouslySetInnerHTML={{ __html: privacyData.texte || privacyData.descriptif || "<p>Contenu non disponible</p>" }}
                />
            </div>
        </div>
    );
};

export default MentionLegales;